<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md4 xs12>
                        <v-autocomplete
                          :label="labels.viewType"
                          :items="filterByList"
                          v-model="filters.viewType"
                          item-text="label"
                          item-value="value"
                          data-vv-name="viewType"
                          :data-vv-as="labels.viewType"
                          :error-messages="errors.collect('viewType')"
                          @change="doFetchTrans()"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.id"
                          :label="labels.id"
                          :error-messages="errors.collect('id')"
                          data-vv-name="id"
                          :data-vv-as="labels.id"
                          data-vv-scope="filters"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-autocomplete
                          :items="actionList"
                          v-model="filters.action"
                          :label="labels.action"
                          item-text="label"
                          item-value="value"
                          data-vv-name="action"
                          :data-vv-as="labels.action"
                          :error-messages="errors.collect('action')"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.polNo"
                          :label="labels.polNo"
                          :error-messages="errors.collect('polNo')"
                          data-vv-name="polNo"
                          :data-vv-as="labels.polNo"
                          data-vv-scope="filters"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.clmNo"
                          :label="labels.clmNo"
                          :error-messages="errors.collect('clmNo')"
                          data-vv-name="clmNo"
                          :data-vv-as="labels.clmNo"
                          data-vv-scope="filters"
                        ></v-text-field>
                      </v-flex>
                      <!-- v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.usrRefId"
                          :label="labels.usrRefId"
                          :error-messages="errors.collect('usrRefId')"
                          data-vv-name="usrRefId"
                          :data-vv-as="labels.usrRefId"
                          data-vv-scope="filters"
                        ></v-text-field>
                      </v-flex -->

                      <v-flex md4 xs12>
                        <v-autocomplete
                          :items="statusList"
                          v-model="filters.status"
                          :label="labels.status"
                          item-text="label"
                          item-value="value"
                          data-vv-name="status"
                          :data-vv-as="labels.status"
                          :error-messages="errors.collect('status')"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex md4 xs12>
                        <cal-picker
                          v-model="filters.txnStartDate"
                          :label="labels.txnStartDate"
                          :data-vv-as="labels.txnStartDate"
                          data-vv-name="txnStartDate"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md4 xs12>
                        <cal-picker
                          v-model="filters.txnEndDate"
                          :label="labels.txnEndDate"
                          :data-vv-as="labels.txnEndDate"
                          data-vv-name="txnEndDate"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-autocomplete
                          :items="statusList"
                          v-model="filters.respStatus"
                          :label="labels.respStatus"
                          item-text="label"
                          item-value="value"
                          data-vv-name="respStatus"
                          :data-vv-as="labels.respStatus"
                          :error-messages="errors.collect('respStatus')"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex md4 xs12>
                        <cal-picker
                          v-model="filters.respStartDate"
                          :label="labels.respStartDate"
                          :data-vv-as="labels.respStartDate"
                          data-vv-name="respStartDate"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md4 xs12>
                        <cal-picker
                          v-model="filters.respEndDate"
                          :label="labels.respEndDate"
                          :data-vv-as="labels.respEndDate"
                          data-vv-name="respEndDate"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-flex xs12>
        <v-flex xs12 class="mt-1">
          <message :messages="messages"></message>
        </v-flex>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="{ 'items-per-page-options': itemsPerPage }"
            :loading="loading"
            :server-items-length="totalItems"
            v-bind:options.sync="pagination"
            :no-data-text="noDataText"
            class="elevation-1"
          >
            <template v-slot:item="row">
              <tr>
                <td class="text-xs-left">{{ row.item.id }}</td>
                <!-- td class="text-xs-left">{{ row.item.action }}</td -->
                <!-- td class="text-xs-left">{{ row.item.usrRefId }}</td -->
                <td class="text-xs-left">{{ formatDisplayDateTime(row.item.txnStartDate) }}</td>
                <td class="text-xs-left">{{ formatDisplayDateTime(row.item.txnEndDate) }}</td>
                <td class="text-xs-left">
                  <v-btn small color="light-gray" @click.native="doFetchApiInfo('Request', row.item)" :disabled="row.item.request === null">
                    {{ showPolClmNo(row.item, true) }}
                  </v-btn>
                </td>
                <td class="text-xs-left">
                  <div v-if="row.item.status !== 'Error'">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon large :color="row.item.color" v-on="on">{{ row.item.icon }}</v-icon>
                      </template>
                      <span>{{ row.item.status }}</span>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    <PubAPITransTblAction
                      :rowData="row.item"
                      :isResp="false"
                      @retryConfirmation="retryConfirmation(row.item, true)"
                      @showError="doShowError(row.item)"
                    ></PubAPITransTblAction>
                  </div>
                </td>
                <td class="text-xs-left">{{ formatDisplayDateTime(row.item.respStartDate) }}</td>
                <td class="text-xs-left">{{ formatDisplayDateTime(row.item.respEndDate) }}</td>
                <td class="text-xs-left">
                  <v-btn small color="light-gray" @click.native="doFetchApiInfo('Response', row.item)" :disabled="row.item.response === null">
                    {{ showPolClmNo(row.item, false) }}
                  </v-btn>
                </td>
                <td class="text-xs-left">
                  <div v-if="row.item.respStatus !== 'Error'">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon large :color="row.item.respColor" v-on="on">{{ row.item.respIcon }}</v-icon>
                      </template>
                      <span>{{ row.item.respStatus }}</span>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    <PubAPITransTblAction
                      :rowData="row.item"
                      :isResp="true"
                      @retryConfirmation="retryConfirmation(row.item, false)"
                      @showRespError="doShowRespError(row.item)"
                    ></PubAPITransTblAction>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>

    <v-dialog scrollable v-model="apiInfoDialog" width="800px">
      <v-card>
        <v-card-title>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>{{ 'API ' + pubApiField + ' Info' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon color="red darken-1" text @click.native="apiInfoDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <pre>{{ pubApiInfo }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="errorDialog" width="800px">
      <v-card>
        <v-card-title>
          <v-icon>mdi-alert</v-icon>
          <v-toolbar-title>Error Messages</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon color="red darken-1" text @click.native="errorDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <pre>{{ errMsg }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>

    <confirm v-model="retryPostingConfirmation" @ok="retryOk(true)">
      <pre>Are you sure you want to post again?</pre>
      <pre>Transaction id: {{ retryItem.id }}</pre>
    </confirm>
    <confirm v-model="retryResponseConfirmation" @ok="retryOk(false)">
      <pre>Are you sure you want to send the reponse?</pre>
      <pre style="center">Transaction id: {{ retryItem.id }}</pre>
    </confirm>
  </page>
</template>
<script>
import { formatDisplayDate2, formatDisplayDateTime4, formatDisplayDateTime2, removeTime } from '@/utils/date'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import clone from 'clone'
import { extractMenu } from '@/utils/extract'
import PubAPITransTblAction from '../misc/mixinsComp/PubAPITransTblAction'
import { custLogTypeView } from '@/const/underwriting'

export default {
  data() {
    return {
      menu: {},
      retryItem: 0,
      itemsPerPage: [5, 10, 25, 50, 100],
      retryPostingConfirmation: false,
      retryResponseConfirmation: false,
      errorDialog: false,
      errMsg: null,
      apiInfoDialog: false,
      pubApiInfo: {},
      pubApiField: null,
      totalItems: 0,
      headers: [
        { text: 'Txn. Id', value: 'id' },
        // { text: 'Action', value: 'action' },
        // { text: 'Requested by', value: 'usrRefId' },
        { text: 'Txn. Start Date', value: 'txnStartDate' },
        { text: 'Txn. End Date', value: 'txnEndDate' },
        { text: 'Request Info', value: 'request' },
        { text: 'Txn. Status', value: 'status' },
        { text: 'Response Start Date', value: 'respStartDate' },
        { text: 'Response End Date', value: 'respEndDate' },
        { text: 'Response Info', value: 'response' },
        { text: 'Response Status', value: 'respStatus' }
      ],
      labels: {
        viewType: 'Filter By',
        id: 'Transaction Id',
        action: 'Action',
        status: 'Transaction Status',
        txnStartDate: 'Transaction Start Date',
        txnEndDate: 'Transaction End Date',
        usrRefId: 'Requested By',
        respStatus: 'Response Status',
        respStartDate: 'Response Start Date',
        respEndDate: 'Response End Date',
        polNo: 'Policy No.',
        clmNo: 'Claim No.'
      },
      filters: {
        viewType: 'ALL',
        id: null,
        action: null,
        status: null,
        txnStartDate: null,
        txnEndDate: null,
        usrRefId: null,
        respStatus: null,
        respStartDate: null,
        respEndDate: null,
        polNo: null,
        clmNo: null
      },
      items: [],
      pagination: {
        sortBy: [],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 5
      },
      actionList: [],
      statusList: [],
      loading: false,
      fab: false
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.$store.state.app.menu.pubapi
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.menu = extractMenu(data._links)
          }
        } catch (err) {
          throw err
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doFetchTrans(options) {
      const apiURI = this.menu.pubApiTrans
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.txnStartDate !== null && massageFilters.txnStartDate !== '') {
            massageFilters.txnStartDate = formatDisplayDateTime2(removeTime(massageFilters.txnStartDate))
          }
          if (massageFilters.txnEndDate !== null && massageFilters.txnEndDate !== '') {
            massageFilters.txnEndDate = formatDisplayDateTime2(removeTime(massageFilters.txnEndDate))
          }
          if (massageFilters.respStartDate !== null && massageFilters.respStartDate !== '') {
            massageFilters.respStartDate = formatDisplayDateTime2(removeTime(massageFilters.respStartDate))
          }
          if (massageFilters.respEndDate !== null && massageFilters.respEndDate !== '') {
            massageFilters.respEndDate = formatDisplayDateTime2(removeTime(massageFilters.respEndDate))
          }

          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            const { data } = result.data
            this.items = []
            if (data) {
              this.totalItems = result.data.totalElements
              data.map(i => {
                this.items.push(i)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doFetchSelLists() {
      const apiURI = this.menu.getPubApiTransSelList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          if (result) {
            const { data } = result
            data.data.action.map(a => {
              this.actionList.push(a)
            })
            data.data.status.map(a => {
              this.statusList.push(a)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    formatDisplayDate(myDate) {
      return formatDisplayDate2(myDate)
    },
    formatDisplayDateTime(myDate) {
      return formatDisplayDateTime4(myDate)
    },
    showPolClmNo(item, showAction) {
      let strjsonRes = JSON.parse(item.request)
      let result = ''
      if (this.showJsonObjInfo(strjsonRes, 'appID') === 'CLM') {
        result = this.showClmNo(item, strjsonRes)
      } else {
        result = item.polNo
      }
      if (showAction === true) {
        result = result + '/' + this.showJsonObjInfo(strjsonRes, 'action')
      }
      return result
    },
    showClmNo(item, strjsonRes) {
      if (item.clmNo) {
        return item.clmNo
      } else {
        return this.showRlatClmRefNo(strjsonRes)
      }
    },
    showRlatClmRefNo(strjsonRes) {
      let result = ''
      if (strjsonRes != null) {
        let rlatClmRefNo = JSON.parse(strjsonRes.obj)
        if (rlatClmRefNo != null) {
          result = rlatClmRefNo.rlatClmRefNo
        }
      }
      return result
    },
    showJsonObjInfo(strjsonRes, key) {
      if (strjsonRes != null) {
        switch (key) {
          case 'action':
            return strjsonRes.action
          case 'txnCode':
            return strjsonRes.txnCode
          case 'status':
            return strjsonRes.status
          case 'appID':
            return strjsonRes.appID
          default:
            return 'info'
        }
      }
      return 'info'
    },
    doFilters() {
      this.$validator.validateAll('filters').then(result => {
        if (result) {
          this.pagination.page = 1
          this.doFetchTrans(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.viewType = 'ALL'
      this.filters.action = null
      this.filters.status = null
      this.filters.txnStartDate = null
      this.filters.txnEndDate = null
      this.filters.usrRefId = null
      this.filters.respStatus = null
      this.filters.respStartDate = null
      this.filters.respEndDate = null
      this.filters.polNo = null
      this.filters.clmNo = null
      this.filters.id = null
      this.pagination.sortBy = []
      this.pagination.sortDesc = [true]
      this.pagination.page = 1
      this.pagination.itemsPerPage = 5
      this.doFetchTrans(false)
    },
    doShowError(item) {
      this.errMsg = ''
      if (!(item.status !== 'Error' && (item.errMsg === undefined || item.errMsg === null || item.errMsg === ''))) {
        this.errorDialog = true
        this.errMsg = item.errMsg
      }
    },
    doShowRespError(item) {
      this.errMsg = ''
      if (!(item.respStatus !== 'Error' && (item.respErrMsg === undefined || item.respErrMsg === null || item.respErrMsg === ''))) {
        this.errorDialog = true
        this.errMsg = item.respErrMsg
      }
    },
    doFetchApiInfo(field, item) {
      this.apiInfoDialog = true
      this.pubApiField = field
      if (field === 'Request') {
        this.pubApiInfo = JSON.parse(item.request)
        let massageApiInfo = clone(this.pubApiInfo)
        let strObj = this.pubApiInfo.obj
        massageApiInfo.obj = JSON.parse(strObj)
        this.pubApiInfo = massageApiInfo
      } else {
        this.pubApiInfo = JSON.parse(item.response)
      }
    },
    async doRetry(item, isPolicy) {
      let selectedItem = item
      const apiURI = isPolicy ? this.menu.retryPAPosting : this.menu.retryPAResponse
      if (apiURI) {
        try {
          const expand = {
            id: selectedItem.id
          }
          const result = await this.$http.post(expandURI(apiURI, expand))
          const { data } = result
          if (data.data) {
            // TODO: formatProcess(data.data, data.data.statusCode)
            const index = this.items.indexOf(this.items.find(trans => trans.id === selectedItem.id))
            // has to use this.$set as data in obj or arr has no reactivity
            this.$set(this.items, index, data.data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.notify('The request failed because it is trying to execute an invalid API url.')
      }
    },
    retryConfirmation(item, isPolicy) {
      if (isPolicy) {
        this.retryPostingConfirmation = true
        this.retryResponseConfirmation = false
      } else {
        this.retryPostingConfirmation = false
        this.retryResponseConfirmation = true
      }
      this.retryItem = item
    },
    retryOk(isPolicy) {
      this.doRetry(this.retryItem, isPolicy)
    }
  },
  watch: {
    pagination: function(value) {
      this.doFetchTrans(false)
    }
  },
  computed: {
    noDataText() {
      if (this.loading) {
        return 'Loading...'
      } else {
        return undefined
      }
    },
    filterByList() {
      let result = []
      Object.keys(custLogTypeView).forEach(function (key) {
        const viewType = custLogTypeView[key]
        result.push({
          value: key,
          label: viewType
        })
      })
      return result
    }
  },
  mounted() {
    this.doInit().then(() => {
      this.doFetchSelLists()
      this.doFetchTrans()
    })
  },
  components: {
    PubAPITransTblAction
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss"></style>
